import React, { Component } from 'react'

class FAQItem extends Component {
  constructor(props) {
    super(props)
    this.toggleClass = this.toggleClass.bind(this)
    this.state = {
      active: false,
    }
  }

  toggleClass() {
    const current = this.state.active
    this.setState({ active: !current })
  }

  render() {
    return (
      <div
        className={
          this.state.active
            ? 'qa-section__item qa-section__item--active'
            : 'qa-section__item'
        }
      >
        <div className="qa-section__item-title" onClick={this.toggleClass}>
          <div className="qa-section__item-decor">Q</div>
          <strong>{this.props.question}</strong>
          <span />
        </div>
        <div className="qa-section__item-content">
          <div className="qa-section__item-decor qa-section__item-decor--top">
            A
          </div>
          <div dangerouslySetInnerHTML={{ __html: this.props.answer }} />
        </div>
      </div>
    )
  }
}

export default FAQItem
